import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { I18nextProvider } from 'react-i18next';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from './providers/ThemeProvider';
import { NotificationProvider } from './components/NotificationsCenter/NotificationContext';
import { AppRoutes } from './routes/AppRoutes';
import i18n from './languages/i18n';
import AdComponent from './components/adBanners/adComponent';
import AdBanner from './components/adBanners/AdBanner';

const App: React.FC = () => {
  return (
    <I18nextProvider i18n={i18n}>
      <AuthProvider>
        <ThemeProvider>
          <NotificationProvider>
            <Router>
              <AdComponent adsenseSlot="1234567890" />
              <AdBanner />
              <AppRoutes />
            </Router>
          </NotificationProvider>
        </ThemeProvider>
      </AuthProvider>
    </I18nextProvider>
  );
};

export default App;